<template>
  <ai-nav :showSearchIcon="true" :isAgent="true">
    <div class="app-container">
    <!-- 顶部导航栏 -->
    <div class="nav-bar">
      <div 
        v-for="tab in tabs" 
        :key="tab.id" 
        :class="['nav-item', { active: activeTab === tab.id }]"
        @click="activeTab = tab.id"
      >
        {{ tab.label }}
      </div>
    </div>

    <!-- 内容卡片区域 -->
    <div class="content-grid">
      <div 
        v-for="card in cards" 
        :key="card.id" 
        class="content-card"
        @click="routerblank('/agentChat?id=' + card.id+'&title='+card.title+'&type=agent')"
      >
        <div class="card-icon">
          <img class="card-image" :src="card.image" alt=""/>
          <!-- <span v-if="card.icon === '@'">@</span>
          <span v-else-if="card.icon === '自'">自</span>
          <span v-else-if="card.icon === '付'">付</span>
          <span v-else>{{ card.icon || '📄' }}</span> -->
        </div>
        <div class="card-content">
          <h3>{{ card.title }}</h3>
          <p>{{ card.summary }}</p>
        </div>
      </div>
    </div>
  </div>
  </ai-nav>
  
</template>

<script>
import aiNav from '../inc/aiNav.vue';
export default {
  name: 'WorkContentPage',
  components: {
    aiNav
  },
  data() {
    return {
      activeTab: 'all',
      userdata: {},
      kw: '',
      tabs: [
        { id: 'all', label: '全部' },
        { id: 'work', label: '行业研究' },
        { id: 'marketing', label: '市场分析' },
        { id: 'education', label: '战略分析' },
      ],
      cards: []
    }
  },
  mounted() {
    // 这里可以添加一些初始化逻辑
    this.userdata = this.getuseriformation();
    this.initAgentList();
   

  },
  methods: {
    initAgentList() {
      this.getList();
    },
    //获取智能体列表
    getList(){
      let kw = this.splicing('kw', this.kw);
      let ajaxUrl = this.$api.common.tencent.assistantList() + '?page=1' +'&pageSize=12'+ kw ;
      this.$axios.get(ajaxUrl, { headers: { AuthToken: this.userdata.token } }).then(res => { 
        if (res.data.success) { 
          console.log(res);
          this.cards = res.data.list;
        }
      });
    },
    getHistory() {
    }  
  }
}
</script>

<style scoped lang="scss">
.app-container {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  /* max-width: 1200px; */
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  background-color: white;
}

/* 导航栏样式 */
.nav-bar {
  display: flex;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 20px;
  overflow-x: auto;
  white-space: nowrap;
}

.nav-item {
  padding: 12px 16px;
  cursor: pointer;
  color: #666;
  font-size: 14px;
  transition: all 0.3s;
}

.nav-item:hover {
  color: #333;
}

.nav-item.active {
  color: #1890ff;
  border-bottom: 2px solid #1890ff;
  font-weight: 500;
}

/* 内容卡片区域 */
.content-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(270px, 1fr));
  gap: 16px;
}

.content-card {
  display: flex;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s;
  cursor: pointer;
  height: 100%;
  box-sizing: border-box;
}

.content-card:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.card-icon {
  width: 40px;
  height: 40px;
  //background-color: #f5f5f5;
  // border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
  font-size: 18px;
  img{
    width: 100%;
    height: 100%;
    border-radius: 4px;
    object-fit: cover;
    object-position: center;
    overflow: hidden;
    position: relative;
    z-index: 1;
  }
}

.card-content {
  flex: 1;
  overflow: hidden;
}

.card-content h3 {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-content p {
  margin: 0;
  font-size: 12px;
  color: #999;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>